import { unsafeCSS } from 'lit';

import styles from './css/global.css?inline';
import skeleton from './css/skeleton.css?inline';

export const globalStyles = unsafeCSS(styles);
export const skeletonStyles = unsafeCSS(skeleton);
